import React, {useState} from 'react';
import {
  Box,
  Button,
  Chip,
  Menu,
  MenuItem,
  Typography,
  Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';

import {
  GREEN_TERTIARY,
  GREEN_NAV,
  TEAL_PRIMARY,
  INFO_100,
  GREY_80,
} from '../../theme';

const PrintDropdownButton = ({menuItems}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        onClick={handleOpenMenu}
        variant="contained"
        sx={{
          backgroundColor: TEAL_PRIMARY,
          borderRadius: '6px',
          height: '32px',
          '&:hover': {
            backgroundColor: TEAL_PRIMARY,
          },
        }}
      >
        <Typography sx={{fontSize: '14px', fontWeight: 500}}>
          Download
        </Typography>
        <ExpandMoreIcon sx={{width: 16, height: 16, ml: 0.8}} />
      </Button>

      <Menu
        sx={{mt: '45px'}}
        disableAutoFocusItem={true}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        slotProps={{
          paper: {
            style: {
              width: '260px',
              borderRadius: '4px',
              boxShadow: '0px 2px 12px 2px rgba(15, 30, 36, 0.12)',
              padding: '0px 0px 0px 0px',
              border: `1px solid ${GREY_80}`,
            },
          },
        }}
      >
        {menuItems.map((item) => {
          if (item.hidden) {
            return <></>;
          }
          if (item.type === 'divider') {
            return (
              <Divider
                key={item.key}
                sx={{my: 1, borderBottomWidth: '2px', borderColor: GREY_80}}
              />
            );
          }
          if (item.type === 'title') {
            return (
              <Typography
                key={item.key}
                color={INFO_100}
                fontWeight={600}
                fontSize={10}
                px={2}
                py={1}
              >
                {item.title}
              </Typography>
            );
          }
          const showMetaBadge =
            Boolean(item.metaHoverTitle) && item.shouldReveal === true;

          return (
            <MenuItem
              key={item.key}
              disabled={item.disabled}
              onClick={(event) => {
                if (item.manualClose) {
                  item.onClick(event, handleCloseMenu);
                } else {
                  item.onClick(event);
                  handleCloseMenu();
                }
              }}
              sx={{
                height: 32,
                display: 'flex',
                justifyContent: showMetaBadge ? 'space-between' : 'flex-start',
                alignItems: 'center',
                gap: showMetaBadge ? 0.75 : 0,
              }}
            >
              <Typography
                color="#052E28"
                fontWeight={400}
                fontSize={14}
                sx={{
                  ...(showMetaBadge
                    ? {
                        flex: 1,
                        minWidth: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }
                    : {}),
                }}
              >
                {item.title}
              </Typography>
              {showMetaBadge && (
                <Chip
                  label={item.metaHoverTitle}
                  size="small"
                  sx={{
                    flexShrink: 0,
                    height: 18,
                    '& .MuiChip-label': {
                      px: 0.75,
                      fontSize: 10,
                      fontWeight: 600,
                      textTransform: 'uppercase',
                    },
                    backgroundColor: GREEN_TERTIARY,
                    color: GREEN_NAV,
                  }}
                />
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

PrintDropdownButton.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string,
      metaHoverTitle: PropTypes.string,
      shouldReveal: PropTypes.bool,
      disabled: PropTypes.bool,
      hidden: PropTypes.bool,
      manualClose: PropTypes.bool,
      onClick: PropTypes.func,
      type: PropTypes.oneOf(['item', 'title', 'divider']).isRequired,
    })
  ).isRequired,
};

export default PrintDropdownButton;
